import React from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import { Icon } from '@iconify/react';
import AuthorWidget from '../Widget/AuthorWidget';
import { pageTitle } from '../../helpers/PageTitle';

export default function Blog5() {
  pageTitle('Energy Storage: The Missing Link in Renewable Power');
  
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = {
      name: formData.get('name'),
      email: formData.get('email'),
      comment: formData.get('comment')
    };
    console.log('Sending to company email:', data);
  };

  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="Energy Storage: The Missing Link in Renewable Power"
        variant="text-center"
        shape="shape_5"
        category="Energy Storage"
        date="24 Oct 2024"
        avatar="Technology Innovation"
        avatarLink="/"
      />
      <Spacing lg="75" md="60" />
      <div className="container">
        <img
          src="/images/blog/post_details_1.jpeg"
          alt="Energy Storage Solutions"
          className="cs_radius_15"
        />
        <div className="cs_height_60 cs_height_lg_40" />
        <div className="cs_post_details">
          <h3>
            Revolutionary Energy Storage Solutions for Continuous Power
          </h3>
          <p>
            Modern battery technology has transformed renewable energy from an intermittent power source to a reliable, 24/7 energy solution. Learn how our advanced storage systems ensure continuous power supply, even when the sun isn't shining or the wind isn't blowing.
          </p>
          <p>
            With storage capacity options ranging from 10kWh to 1MWh, our solutions can be tailored to meet any residential or commercial need, ensuring energy independence and reliability.
          </p>
          <div className="cs_height_10 cs_height_lg_5" />
          <div className="row">
            <div className="col-md-4">
              <img
                src="/images/blog/post_details_2.jpeg"
                alt="Battery Systems"
                className="w-100"
              />
            </div>
            <div className="col-md-4">
              <img
                src="/images/blog/post_details_3.jpeg"
                alt="Storage Integration"
                className="w-100"
              />
            </div>
            <div className="col-md-4">
              <img
                src="/images/blog/post_details_4.jpeg"
                alt="Power Management"
                className="w-100"
              />
            </div>
          </div>
          <div className="cs_height_10 cs_height_lg_5" />
          <h3>Advanced Storage Technologies</h3>
          <p>
            Our latest lithium-ion storage systems feature smart power management, remote monitoring, and automatic load balancing. These features maximize efficiency and extend battery life while ensuring optimal power distribution.
          </p>
          <blockquote>
            "The addition of energy storage to our solar system has eliminated our power concerns completely. We haven't experienced a single outage since installation, even during severe weather."
            <small>Sarah Martinez, Homeowner</small>
          </blockquote>
          <p>
            Soketry Solutions offers comprehensive energy storage solutions that integrate seamlessly with new or existing renewable energy systems. Our expert team ensures proper sizing and installation for maximum benefit.
          </p>
          <ul>
            <li>10-year warranty on all battery systems</li>
            <li>Smart power management and monitoring</li>
            <li>Scalable solutions for growing needs</li>
            <li>Emergency backup power capability</li>
            <li>Integration with existing solar/wind systems</li>
          </ul>
        </div>
        <div className="cs_height_30 cs_height_lg_10" />
        <div className="cs_post_share">
          <div className="cs_categories">
            <a href="/" className="cs_category">
              Energy Storage
            </a>
            <a href="/" className="cs_category">
              Battery Technology
            </a>
          </div>
          <div className="text-center">
            <div className="cs_post_share_btns">
              <a href="/">
                <Icon icon="fa6-brands:twitter" />
              </a>
              <a href="/">
                <Icon icon="fa6-brands:facebook-f" />
              </a>
              <a href="/">
                <Icon icon="fa6-brands:linkedin-in" />
              </a>
            </div>
            <span className="cs_post_share_title">Share this Article</span>
          </div>
        </div>
        <div className="cs_height_50 cs_height_lg_40" />
        <AuthorWidget />
        <div className="cs_height_88 cs_height_lg 60" />
        <h2 className="text-center cs_fs_50 mb-0">Leave A Comment</h2>
        <div className="cs_height_60 cs_height_lg 30" />
        <form onSubmit={handleSubmit} className="row">
          <div className="col-lg-6">
            <input
              type="text"
              name="name"
              className="cs_form_field_2"
              placeholder="Your Name"
              required
            />
            <div className="cs_height_50 cs_height_lg 30" />
          </div>
          <div className="col-lg-6">
            <input
              type="email"
              name="email"
              className="cs_form_field_2"
              placeholder="Your Email"
              required
            />
            <div className="cs_height 50 cs_height_lg 30" />
          </div>
          <div className="col-lg-12">
            <textarea
              name="comment"
              cols={30}
              rows={7}
              className="cs_form_field_2"
              placeholder="Share your thoughts on energy storage solutions"
              required
            />
            <div className="cs_height 60 cs_height_lg 30" />
          </div>
          <div className="col-lg-12 text-center">
            <button type="submit" className="cs_btn cs_style_1">
              Submit Comment{' '}
              <span>
                <i className="fa-solid fa-arrow-right" />
              </span>
            </button>
          </div>
        </form>
        <div className="cs_height_150 cs_height_lg 80" />
      </div>
    </>
  );
} 